import { instance } from "../axios/axiosConfig.ts";
import { AssignPersonasBodyType } from "../types/personaGroupsTypes.tsx";

const personaGroupsApi = {
  fetchPersonaGroups() {
    return instance.get(`/api/persona-groups/`);
  },

  createPersonaGroup(body: {
    name: string;
    description?: string;
    is_platform?: boolean;
  }) {
    return instance.post(`/api/persona-groups/`, body);
  },

  deletePersonaGroup(id: number) {
    return instance.delete(`/api/persona-groups/${id}/`);
  },

  fetchPersonaGroupPersonas(id: number) {
    return instance.get(`/api/persona-groups/${id}/personas/`);
  },

  assignPersonas(id: number, body: AssignPersonasBodyType) {
    return instance.post(`/api/persona-groups/${id}/assign_personas/`, body);
  },

  removePersonas(id: number, body: AssignPersonasBodyType) {
    return instance.post(`/api/persona-groups/${id}/remove_personas/`, body);
  },
};

export default personaGroupsApi;
